// import React from "react";

// const sizeClasses = {
//   sm: "w-3 h-3",
//   md: "w-4 h-4",
//   lg: "w-5 h-5",
//   xl: "w-6 h-6",
// };

// const fontSizeClasses = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const CustomCheckbox = ({
//   options = [],
//   selectedValues = [],
//   onChange,
//   multiple = false,
//   size = "md",
// }) => {
//   const handleChange = (value) => {
//     if (multiple) {
//       const updatedValues = selectedValues.includes(value)
//         ? selectedValues.filter((v) => v !== value)
//         : [...selectedValues, value];

//       onChange(updatedValues);
//     } else {
//       onChange(value === selectedValues ? "" : value);
//     }
//   };

//   return (
//     <div className={`flex flex-wrap gap-4`}>
//       {options.map((option) => (
//         <label
//           key={option.value}
//           className={`flex items-center cursor-pointer ${fontSizeClasses[size]}`}
//         >
//           <input
//             type="checkbox"
//             checked={
//               multiple
//                 ? selectedValues.includes(option.value)
//                 : selectedValues === option.value
//             }
//             onChange={() => handleChange(option.value)}
//             className={`mr-2 ${sizeClasses[size]}`}
//           />
//           {option.label}
//         </label>
//       ))}
//     </div>
//   );
// };

// export default CustomCheckbox;

import React from "react";

const sizeClasses = {
  sm: "w-3 h-3",
  md: "w-4 h-4",
  lg: "w-5 h-5",
  xl: "w-6 h-6",
};

const fontSizeClasses = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

// Define color classes
const colorClasses = {
  primary:
    "peer-checked:bg-primary peer-checked:border-primary peer-checked:text-white",
  warning: "peer-checked:bg-warning peer-checked:border-warning",
  success: "peer-checked:bg-success peer-checked:border-success",
  danger: "peer-checked:bg-danger peer-checked:border-danger",
  black: "peer-checked:bg-black peer-checked:border-black",
  white: "peer-checked:bg-white peer-checked:border-white",
};

const hoverColorClasses = {
  primary: "group-hover:border-primary",
  warning: "group-hover:border-warning",
  success: "group-hover:border-success",
  danger: "group-hover:border-danger",
  black: "group-hover:border-black",
  white: "group-hover:border-white",
};

const CustomCheckbox = ({
  options = [],
  selectedValues = [],
  onChange,
  multiple = false,
  size = "md",
  color = "primary", // primary, warning, success, danger, black, white
  list = false,
  disabled = false,
}) => {
  const handleChange = (value) => {
    if (multiple) {
      const updatedValues = selectedValues.includes(value)
        ? selectedValues.filter((v) => v !== value)
        : [...selectedValues, value];
      onChange(updatedValues);
    } else {
      onChange(value === selectedValues ? "" : value);
    }
  };

  return (
    <div className={`flex ${list ? "flex-col gap-2" : "flex-wrap gap-4"}`}>
      {options.map((option) => (
        <label
          key={option.value}
          className={`select-none group flex items-center cursor-pointer transition-all duration-200 ${fontSizeClasses[size]}`}
        >
          <input
            type="checkbox"
            value={option.value}
            checked={
              multiple
                ? selectedValues.includes(option.value)
                : selectedValues === option.value
            }
            // checked={selectedValues.includes(option.value)}
            onChange={() => handleChange(option.value)}
            className="hidden peer"
            disabled={disabled}
          />
          <div
            className={`mr-2 flex justify-center items-center border-[1px] border-neutrals transition-all duration-700 rounded-sm
            ${sizeClasses[size]} ${colorClasses[color]} ${hoverColorClasses[color]} relative`}
          >
            {/* Checkbox background */}
            <div
              className={`w-full h-full rounded-sm transition-all duration-300 aspect-square
                ${
                  multiple
                    ? selectedValues.includes(option.value)
                      ? "bg-primary"
                      : "bg-transparent"
                    : selectedValues === option.value
                    ? "bg-primary"
                    : "bg-transparent"
                }`}
            >
              {/* Conditionally render a real checkmark icon */}
              {selectedValues.includes(option.value) && (
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={
                      size === "sm"
                        ? "12"
                        : size === "md"
                        ? "14"
                        : size === "lg"
                        ? "16"
                        : "18"
                    }
                    height={
                      size === "sm"
                        ? "12"
                        : size === "md"
                        ? "14"
                        : size === "lg"
                        ? "16"
                        : "18"
                    }
                    className="text-white"
                  >
                    <path
                      fill="currentColor"
                      d="M10 15l-3.5-3.5L5 13l5 5L19 7l-1.5-1.5z"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default CustomCheckbox;
